import * as Sentry from '@sentry/react';

import Service from "core/decorators/Service";
import { currentMode } from "../../../util/Mode";
import { ErrorSource, IError, ILoggerService } from "../ILoggerService";

@Service()
class RavenLoggerService extends ILoggerService {
	private sentErrors: Record<string, { timestamp: number }> = {};

	constructor() {
		super();

		/*window.addEventListener('error', function(e){
			// prevent React's listener from firing
			e.stopImmediatePropagation();
			// prevent the browser's console error message
			e.preventDefault();
			console.log('hujh');
		});*/
	}

	public reportError(source: ErrorSource, error: IError, location: string, errorCode?: string): string {
		// generate randomly like "VX94K3Q"
		const code = errorCode || Math.random().toString(36).slice(2).toUpperCase();

		// only send the error if the app is in prod mode and we have not already sentit to sentry
		if(currentMode.isProd() && !this.sentErrors[code]) {

			console.log("Sending error to Sentry. ERROR CODE: " + code);
			console.log(error);

			/*Raven.captureException(error.message, {
				extra: error.info,
				tags: {code}
			});*/

			Sentry.captureException(error.message, {
				extra: {
					info: error.info
				},
				tags: {
					errorCode: code
				}
			});

			console.log("sentry capture complete");

			this.sentErrors[code] = { timestamp: Date.now() };
		} else {
			console.log("Caught error: ");
			console.error(error);
		}

		return code;
	}

	public getServiceId(): string {
		return "raven";
	}

}



// WEBPACK FOOTER //
// ./src/core/service/logger/impl/RavenLogger.service.ts